export function PerfectionIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 8l-4 10h-12l10 7-4 11 10-7 10 7-4-11 10-7h-12z" />
    </svg>
  );
}
